import ConfigurationService from "./ConfigurationService";

export default class CustomEvents {
  static trigger(eventName, ...args) {
    const eventFunction = ConfigurationService.getEvent(eventName);

    if (eventFunction) {
      eventFunction.apply(null, args);
    }
  }
}
